export default __webpack_public_path__ + "images/AR-icon.21d60e218b3fc17ab10deb697a4285d6.png";